<template>
    <div class="parkinglot_lists">
      <loading v-if="loading"/>
      <!-- 找停車場_lists -->
      <section class="parkinglot-section">
        <div class="container">
          <div class="row parkinglot-lists-title">
            <div class="col-lg-12 text-center">
              <h2 class="section-heading text-uppercase">Parking Lots</h2>
              <h3 class="section-subheading text-muted parkinglot-subheading">找停車場</h3>
              
              <div class="parkinglot-switch-box">
                <router-link :to="'parkinglot_lists'"><div class="parkinglot-switch fl">列表顯示</div></router-link>
                <router-link :to="'parkinglot_map'"><div class="parkinglot-switch fl">地圖顯示</div></router-link>
                <div class="cb"></div>
              </div>
            </div>
          </div>
          <div class="row">


            <div class="col-lg-12 parkinglot-lists-box row">

              <div class="col-lg-6" v-for="lot in lots" :key="lot.id">
                  <router-link :to="'parkinglot_view?id=' + lot.id">
                        <div class="parkinglot-card parkinglot-lists-item">
                            
                            <div class="parkinglot-open fl" v-if="lot.open"><i class="fas fa-circle"></i>OPEN</div>
                            <div class="parkinglot-closed fl" v-if="!lot.open"><i class="fas fa-ban"></i>CLOSED</div>
                            <div class="parkinglot-distance fr" v-if="lot.distance"><i class="fas fa-location-arrow"></i>{{ lot.distance.toFixed(1) }} km</div>
                            <div class="cb"></div>
                            
                            <div class="parkinglot-name">{{ lot.name }}</div>

                            <div class="parkinglot-currentpay"><span>目前收費</span><i class="fas fa-angle-right"></i>30 / 小時</div>
                            <!--<div class="parkinglot-enter"><span>進場方式</span><i class="fas fa-angle-right"></i>車牌辨識</div>-->
                            <div class="parkinglot-addr"><span>車場地址</span><i class="fas fa-angle-right"></i>{{ lot.addr }}</div>
                            
                        </div><!--parkinglot-card ends-->

                  </router-link>
              </div>

              <!--<div class="col-lg-6" v-for="lot in lots" :key="lot.id">
                <router-link :to="'parkinglot_view?id=' + lot.id">
                  <div class="parkinglot-card parkinglot-lists-item">
                      {{ lot.name }}
                  </div>
                </router-link>
              </div>-->


            </div><!--parkinglot-lists-box ends-->     



          </div>
        </div>
      </section>
    </div>
</template>

<script>
export default {
  name: 'ParkinglotLists',
  components: {
  },
  props: {
  },
  data() {
    return {
      lots: [],
      loading: true
    }
  },
  mounted() {
    var self = this;
    self.getLots()
  },
  methods: {
    getLots: function() {
      var self = this
      self.$http.get('https://' + process.env.VUE_APP_API_URL + '/lots?brand=' + process.env.VUE_APP_BRAND)
        .then((response) => {
          if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(function(position) {
                  for(var i = 0; i < response.body.length; i ++) {
                      response.body[i].distance = calcCrow(position.coords.latitude, position.coords.longitude, response.body[i].latitude, response.body[i].longitude)
                  }
                  self.loading = false
                  self.lots = sortByKey(response.body, 'distance')
              }, function(error) {
                  self.loading = false
                  self.lots = response.body
              }, {
                timeout: 2000
              });
          } else {
              self.loading = false
              self.lots = response.body
          }
        })
        .catch((response) => {
          console.log("取得資料失敗")
          self.$router.push({ name: 'member_center' })
        })
        .finally(() => {
        });
    },
  }
}

function calcCrow(lat1, lon1, lat2, lon2) {
  var R = 6371; // km
  var dLat = toRad(lat2-lat1);
  var dLon = toRad(lon2-lon1);
  var lat1 = toRad(lat1);
  var lat2 = toRad(lat2);

  var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  var d = R * c;
  return d;
}
function toRad(Value) {
    return Value * Math.PI / 180;
}

function sortByKey(array, key) {
    return array.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}

</script>